import Color from 'color';
import styled from 'styled-components';

import { Link } from 'gatsby';
import { BLACK, PAPER } from '../../../theme/colors';
import { SIZE, mediaQuery, unit } from '../../../theme/metrics';
import { typeLabelMd } from '../../../theme/typography';
import { BlockHeader } from '../block-header';


export const StyledHeader = styled(BlockHeader)`
  grid-column: span 12;
`

export const StyledGridItem = styled.div`
	grid-column: span 12;
  position: relative;

	${mediaQuery[SIZE.medium]} {
		grid-column: span 4;
	}
`

export const StyledItemThumbnail = styled.div`
	position: relative;

	&:after{
		content: "Read more";
		${typeLabelMd};
		color: ${PAPER};
		position: absolute;
		background-color: ${Color(BLACK).alpha(0.8).string()};
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity 0.5s;
	}
`

export const StyledItemContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  row-gap: ${unit(4)};
	text-decoration: none;

	&:hover {
		${StyledItemThumbnail}{
			&:after{
				opacity: 1;
			}
		}
	}
`



export const StyledItemCTA = styled.div`
	position: absolute;
  background-color: ${Color(BLACK).alpha(0.4).string()};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
	cursor: pointer;

	svg{
		margin-right: ${unit(1.5)};
  	transition: opacity 300ms;
	}

	${mediaQuery[SIZE.large]} {
		&:hover {
			svg{
        opacity: 0.8;
			}
		}
	}
`

export const StyledItemImage = styled.img``